<template>
	<div class="compensation-box" v-if="inGameCompensation">
		<AppIconButton
			:type="IconTypes.REWARD"
			notification="!"
			@click="openCompensationPopup"
		/>
	</div>
</template>

<script lang="ts" setup>
import AppIconButton from "@/components/AppIconButton.vue";
import CompensationPopup from "@/components/CompensationPopup.vue";
import {
	PopupDictionary,
	PopupType,
	usePopupStore,
} from "@/store/usePopupStore";
import useRewardStore from "@/store/useRewardStore";
import { IconTypes, SkinTypes } from "@/types/ui";
import { translate } from "@/utils/translate";
import { storeToRefs } from "pinia";
import { markRaw } from "vue";

const rewardStore = useRewardStore();
const { inGameCompensation } = storeToRefs(rewardStore);
const popupStore = usePopupStore();

const openCompensationPopup = (): void => {
	popupStore.showPopup({
		id: PopupDictionary.COMPENSATION,
		type: PopupType.INFO,
		heading: translate("ui.special_delivery"),
		skin: SkinTypes.DARK,
		width: 24,
		maxHeight: 25,
		component: markRaw(CompensationPopup),
	});
};
</script>
